import axios from 'axios';

class CourseService {
  getCourse(slug) {
    let url = '/courses/' + slug;
    return axios
      .get(url)
      .then(resp => {
        return resp.data;
      })
      .catch(error => {
        console.log('error', error.response);
        return false;
      });
  }

  getAll(query = null) {
    let url = '/courses/all';
    if (query) url += '?query=' + query;

    return axios
      .get(url)
      .then(resp => {
        return resp.data; // Ensure this returns an array of courses
      })
      .catch(error => {
        console.log('error', error.response);
        return [];
      });
  }
}

// https://k94n.com/es6-modules-single-inst
export let courseservice = new CourseService();
export default courseservice;